import React, { useState } from "react";
import swal from "sweetalert";
import { ContactContainer, ContactForm, ContactLabel, ContactInput, ContactText, ContactButton, SendIcon } from "./contactElements";
import { useTranslation } from "react-i18next";

const ContactSection = () => {

  const { t } = useTranslation();
  const [status, setStatus] = useState(t('contactSendText.txt'));
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(t('contactSendingText.txt'));
    const { name, email, subject, message } = e.target.elements;
    let details = {
      name: name.value,
      email: email.value,
      subject: subject.value,
      message: message.value,
    };
    let response = await fetch("/api/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(details),
    });

    setStatus("SEND");
    let result = await response.json();
    //using sweet alert for beuty
    if (result.status === "SUCCESS") {
      swal({
        icon: "success",
        title: t('contactSuccessTitle.txt'),
        text: t('contactSuccessText.txt'),
      });
    } else {
      swal({
        icon: "error",
        title: t('contactErrorTitle.txt'),
        text: t('contactErrorText.txt'),
      });
    }
  };

  return (
    <ContactContainer>
      <ContactForm onSubmit={handleSubmit} action="#">
        <ContactLabel htmlFor="name"> {t('contactName.txt')}</ContactLabel>
        <ContactInput type="text" id="name" required />
        <ContactLabel htmlFor="email"> Email</ContactLabel>
        <ContactInput type="email" id="email" required />
        <ContactLabel htmlFor="subject"> {t('contactSubject.txt')}</ContactLabel>
        <ContactInput id="subject" type="text" required />
        <ContactLabel htmlFor="message"> {t('contactMessage.txt')}</ContactLabel>
        <ContactText id="message" type="text" required />
        <ContactButton type="submit">
          <SendIcon />
          {status}
        </ContactButton>
        <SendIcon />
      </ContactForm>
    </ContactContainer>
  );
};

export default ContactSection;
